import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row, Form, Button, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Cart_OrderId,
  User_LogIn,
  View_Cart,
  login_OTP,
} from "../../Api";
import { toast } from "react-toastify";
import Logo from "../../assets/images/logo.png";
import { useDispatch } from "react-redux";
import { setLoginStatus } from "../../Redux/loginSlice";
import { FaTimes } from "react-icons/fa";
import { getStyles } from "../../Pages/VerifyDetails/VerifyDetails.style";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { VIEW_CART } from "../../Redux/Cart";
import { useTranslation } from "react-i18next";
import { getFirebaseMessaging } from "../../firebase/firebaseConfig";
import { getToken } from "firebase/messaging";
import { INITIAL_TAB } from "../../Redux/User";
import { AddToWishList } from "../../Utils/wishListUtils";
const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );
      console.log("✅ Service Worker registered:", registration);
    } catch (error) {
      console.error("❌ Service Worker registration failed:", error);
    }
  }
};

const VerifyDetails: React.FC<{ setVerifyDetailsModal: any, productId: any }> = ({ setVerifyDetailsModal, productId }) => {
  const { t, i18n } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = getStyles(isMobile);
  const location = useLocation();
  const [otp, setOtp] = useState<string[]>(["", "", "", "", "", ""]);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [fake, setFake] = useState<any>([]);
  const [lonumber, setLonumber] = useState<string | null>("");
  const [userid, setUserid] = useState<string | null>("");
  const [userOTP, setUserOTP] = useState<any>([]);
  const dispatch = useDispatch();
  const [checkoutStatus, setCheckoutStatus] = useState<string | null>("");
  const [error, setError] = useState({
    otp: "",
  });
  const [fcmToken, setFcmToken] = useState<string | null>(null);

  const [resendTimer, setResendTimer] = useState(60);
  const [isResendDisable, setIsResendDisable] = useState(true)

let intervalId: NodeJS.Timer;

const startResendTimer = () => {
  clearInterval(intervalId); 

  const expiry = localStorage.getItem("otpExpiryTime");
  let remainingTime = 60;

  if (expiry) {
    const now = new Date().getTime();
    remainingTime = Math.floor((parseInt(expiry) - now) / 1000);
    if (remainingTime <= 0) {
      setResendTimer(0);
      setIsResendDisable(false);
      return;
    }
  }

  setResendTimer(remainingTime);
  setIsResendDisable(true);

  intervalId = setInterval(() => {
    setResendTimer(prev => {
      if (prev <= 1) {
        clearInterval(intervalId);
        setIsResendDisable(false);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);
};

useEffect(() => {
  startResendTimer();
  return () => clearInterval(intervalId); 
}, []);



  const navigate = useNavigate();

  const handleChange = (index: number, value: string) => {
    if (value === "") {
      setError((error) => ({
        ...error,
        otp: t("responseMessage.enterOtp"),
      }));
    } else {
      setError((error) => ({
        ...error,
        otp: "",
      }));
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move focus to the next input field
    if (index < otp.length - 1 && value.length === 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  useEffect(() => {
    const number = location.state?.mobileNumber;
    setLonumber(number);
    setUserid(localStorage.getItem(STORAGE_CONSTANTS.USER_ID));
    const storedOTP = localStorage.getItem(STORAGE_CONSTANTS.USER_OTP);
    if (storedOTP && storedOTP.length === 6) {
      const otpArray = storedOTP.split("");
      setFake(otpArray);
      setOtp(otpArray);
    }
    setUserOTP(fake);
    setCheckoutStatus(localStorage.getItem(STORAGE_CONSTANTS.CHECKOUT_STATUS));
  }, []);
  useEffect(() => {
    handleFCMToken();
  }, []);

  const fetchFcmToken = async () => {
    try {
      await registerServiceWorker();
      const messaging = await getFirebaseMessaging();

      if (!messaging) {
        console.error("no valid messaging");
        return "";
      }
      const vapidKey = process.env.REACT_APP_VAPID_KEY;
      const token = await getToken(messaging, {
        vapidKey: vapidKey,
      });
      // console.log("🔥 FCM Token:", token);
      return token;
    } catch (error: any) {
      console.error("⚠️ Error getting FCM token:", error.message);
    }
    return "";
  };

  const handleFCMToken = async () => {
    try {
      const retrievedFCMToken: any = await fetchFcmToken();
      setFcmToken(retrievedFCMToken);
    } catch (error) {
      setFcmToken("");
    }
  };
  const handleResendOTP = async () => {

    try {
      if (!lonumber) {
        toast.error("Phone number is missing!");
        return;
      }
      const deviceType = "web";
      let userFcmToken = fcmToken;

      if (!userFcmToken) {
        userFcmToken = await fetchFcmToken();
      }
      console.log(userFcmToken, "userFcm");

      const response = await User_LogIn({
        mobile_number: lonumber,
        registered_device: userFcmToken,
        device_type: deviceType,
      }); // Call your API function to resend OTP
      if (response && response.status === 200) {
        
        localStorage.setItem(STORAGE_CONSTANTS.USER_OTP, response.data.otp);
        setUserOTP(response.data.otp.toString().split("")); // Update OTP in localStorage
        setOtp(response.data.otp.toString().split("")) // set recent otp. 
        const expiryTime = new Date().getTime() + (60 * 1000);
        localStorage.setItem("otpExpiryTime", expiryTime.toString());
        startResendTimer()
        toast.success("OTP sent successfully");
        // start timer function after resend otp
      } else {
        toast.error(response["data"]["message"]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace") {
      if (otp[index] === "") {
        if (index > 0) {
          const newOtp = [...otp];
          newOtp[index - 1] = "";
          setOtp(newOtp);
          inputRefs.current[index - 1]?.focus();
        }
      } else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
    if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (e.key === "ArrowRight" && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    if (enteredOtp !== "" && enteredOtp.length === 6) {
      const VerifyOTP = async () => {
        try {
          const response = await login_OTP(userid, enteredOtp);
          if (response && response.status === 200) {
            localStorage.setItem(
              STORAGE_CONSTANTS.USER_TOKEN,
              response?.data?.token
            );
            toast.success(response["data"]["message"]);
            setResendTimer(60);

            if (response.data.token) {
              const Cartresponse = await Cart_OrderId();
              if (Cartresponse && Cartresponse.status === 200) {
                if (!localStorage.getItem(STORAGE_CONSTANTS.ORDER_ID)) {
                  localStorage.setItem(
                    STORAGE_CONSTANTS.ORDER_ID,
                    Cartresponse?.data?.cart_details?.order?.id ?? ""
                  );
                }

                const Cartresponses = await View_Cart();
                if (Cartresponses && Cartresponses.status === 200) {
                  dispatch(VIEW_CART(Cartresponses.data));
                }
              }
            }
            localStorage.setItem(STORAGE_CONSTANTS.IS_LOGGED_IN, "true");
            dispatch(setLoginStatus(true));
            if (checkoutStatus === "true") {
              navigate("/view-cart");
            } else {
              navigate("/profile");
              dispatch(INITIAL_TAB("Wishlist")); 
              AddToWishList(productId);
            }
          } else {
            toast.error(response["data"]["message"]);
          }
        } catch (error: any) {
          toast.error(error.response.data.message);
        }
      };
      VerifyOTP();
    } else {
      setError((error) => ({
        ...error,
        otp: t("responseMessage.enterOtp"),
      }));
    }
  };
  return (
    <Container fluid style={{ height: "80vh" }}>
      <Row style={{ height: "100%" }} className="sm-login">
        <Col md={12} style={styles.leftColumnStyle}>
          {/* Left column content */}
          <Link to="/">
            <FaTimes style={styles.closeIcon} className="hide-lg" />{" "}
            {/* Add the close button */}
          </Link>
          <div style={{ textAlign: "left" }}>
            <Link to={`/`}>
              <Image
                src={Logo}
                style={{ width: 224, height: 88, marginBottom: 50 }}
              />
            </Link>
            <h2 style={styles.formTitle}>{t("login.verifyDetails")}</h2>
            <h3 style={styles.formSubtitle}>
              {t("login.enterOtp")} {lonumber}{" "}
            </h3>
            <Form onSubmit={handleSubmit}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    maxLength={1}
                    value={digit}
                    className="form-control"
                    style={styles.input}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                  />
                ))}
              </div>
              <p style={styles.bottomText}>
                {t("login.otpNotReceived")}&nbsp;
                {resendTimer !== 0 ? (
                  <span className='text-muted opacity-75'>
                    Resend OTP in&nbsp;
                    <span>
                      {resendTimer}s
                    </span>
                  </span>
                ) : (
                  <span onClick={handleResendOTP} style={styles.requestAgain}>{t("login.requestAgain")}</span>
                )}
              </p>

              {error && <span style={styles.error}>{error.otp}</span>}

              <Button type="submit" style={styles.btnBlue}>
                {t("login.verify_otp")}
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default VerifyDetails;
